import React, { useCallback, useEffect, useRef, useState } from "react";

import { RegistrationFormController } from "../registrationForm/components/RegistrationFormController";
import { RegistrationFormSkeleton } from "../registrationForm/components/RegistrationFormSkeleton";
import { ProductDescription, ProductDescriptionSkeleton } from "../productInfo/components/ProductDescription";
import { ProductName, ProductNameSkeleton } from "../productInfo/components/ProductName";
import { Logo } from "../productInfo/components/Logo";
import { useLoadProductInfo } from "../productInfo/hooks/useLoadProductInfo";
import { useLoadProductFeatures } from "../productInfo/hooks/useLoadProductFeatures";
import { hasFeature } from "../productInfo/utils";
import { Features } from "../productInfo/constants";

import { parseUrlParams } from "./utils";
import * as styles from "./styles.module.css";

export function App() {
    useEffect(() => {
        if (!document.querySelector("meta[name='viewport']")) {
            const meta = document.createElement("meta");
            meta.name = "viewport";
            meta.content = "width=device-width, initial-scale=1";
            document.head.appendChild(meta);
        }
    }, []);

    const [params] = useState(parseUrlParams(window.location.href));

    const productInfo = useLoadProductInfo(params.productUid);
    const productFeatures = useLoadProductFeatures(params.productUid);

    const isReady = productInfo && productFeatures;

    const formWrapperRef = useRef<HTMLDivElement>(null);
    const resetScrollPosition = useCallback(() => {
        formWrapperRef.current?.scrollTo(0, 0);
    }, []);

    return (
        <div className={styles.wrapper}>
            <div className={styles.centeredLayout}>
                <Logo />
                <div className={styles.content}>
                    <div className={styles.marketingBlock}>
                        <span className={styles.rings} />
                        {productInfo ? (
                            <ProductName
                                trialPeriod={productInfo.trialPeriod}
                                productDisplayName={productInfo.productDisplayName}
                                marketingShortDescription={productInfo.marketingShortDescription}
                            />
                        ) : (
                            <ProductNameSkeleton />
                        )}

                        <div className={styles.productDescription}>
                            {productInfo ? (
                                <ProductDescription
                                    marketingLongDescription={productInfo.marketingLongDescription}
                                />
                            ) : (
                                <ProductDescriptionSkeleton />
                            )}
                        </div>
                    </div>

                    <div className={styles.formWrapper} ref={formWrapperRef}>
                        <div className={styles.form}>
                            {isReady ? (
                                <RegistrationFormController
                                    productUid={productInfo.uid}
                                    provider={params.provider}
                                    errorCode={params.errorCode}
                                    hsCtaAttrib={params.hsCtaAttrib}
                                    onViewChange={resetScrollPosition}
                                    hasDeveloperSandbox={hasFeature({
                                        name: Features.DEVELOPER_SANDBOX,
                                        features: productFeatures.items
                                    })}
                                />
                            ) : (
                                <RegistrationFormSkeleton />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
